import FormControlLabel from '@mui/material/FormControlLabel';
import { withStyles } from '@mui/styles';
import React from 'react';

const CustomFormControlLabel = withStyles({
  root: {
    '& .MuiTypography-root': {
      fontFamily: 'inherit !important',
    },
  },
})(FormControlLabel);

const UiFormControlLabel = (props) => {
  return <CustomFormControlLabel labelPlacement='end' {...props} />;
};

export default UiFormControlLabel;
